import type { PrimitivePalette } from './primitives'
import type { PaletteTypes } from './palette'

export type ThemeMode = 'light' | 'dark'

type MuiPaletteBridge = Pick<PaletteTypes, 'mode' | 'text' | 'background' | 'divider'> & {
  primary: { main: string }
  secondary: { main: string }
}

/** MUI light-palette defaults used before semantic tokens were wired into the bridge. */
const LEGACY_MUI_LIGHT_TEXT = {
  primary: 'rgba(0, 0, 0, 0.87)',
  secondary: 'rgba(0, 0, 0, 0.6)'
} as const

const LEGACY_MUI_LIGHT_DIVIDER = 'rgba(0, 0, 0, 0.12)'

/**
 * @deprecated Internal MUI bridge — do not use in Kurama components or docs. Removed in next major.
 */
export const createLegacyPaletteAliases = (
  primitivePalette: PrimitivePalette
): Omit<PaletteTypes, 'mode' | 'text' | 'background' | 'divider' | 'getContrastText'> => ({
  primary: {
    main: primitivePalette.main.alvieBlue['100']
  },
  secondary: {
    main: primitivePalette.neutrals.alvieBlack['100']
  },
  main: primitivePalette.main,
  neutrals: primitivePalette.neutrals,
  semantic: primitivePalette.semantic,
  dataViz: primitivePalette.dataViz
})

/**
 * @deprecated Internal MUI bridge — do not use in Kurama components or docs. Removed in next major.
 */
export const createMuiPaletteBridge = (mode: ThemeMode, primitivePalette: PrimitivePalette): MuiPaletteBridge => {
  if (mode === 'dark') {
    return {
      mode,
      primary: {
        main: primitivePalette.main.alvieBlue['100']
      },
      secondary: {
        main: primitivePalette.neutrals.white['100']
      },
      text: {
        primary: primitivePalette.neutrals.white['100'],
        secondary: primitivePalette.neutrals.stone['120']
      },
      background: {
        default: primitivePalette.neutrals.alvieBlack['100'],
        paper: primitivePalette.neutrals.stone['180']
      },
      divider: primitivePalette.neutrals.stone['160']
    }
  }

  return {
    mode,
    primary: {
      main: primitivePalette.main.alvieBlue['100']
    },
    secondary: {
      main: primitivePalette.neutrals.alvieBlack['100']
    },
    text: LEGACY_MUI_LIGHT_TEXT,
    background: {
      default: primitivePalette.neutrals.white['100'],
      paper: primitivePalette.neutrals.white['100']
    },
    divider: LEGACY_MUI_LIGHT_DIVIDER
  }
}
